<template>
  <div id="resource">
    <v-container>
      <v-row>
        <h2>{{ $t('resource.text') }}</h2>
      </v-row>
      <v-row>
        <v-text-field
          v-model.trim="searchCriteria"
          clearable
          clear-icon="mdi-close-circle"
          prepend-inner-icon="mdi-magnify"
          @keydown.enter="doSearch"
          color="black"
          outlined
        >
        </v-text-field>
      </v-row>
      <v-row>
        <v-btn
            :dark="!criteriaMissing"
            depressed
            tile
            large
            @click="doSearch()"
            :disabled="criteriaMissing"
        >{{ $t('resource.form.button.label')}}
        </v-btn>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  const BASE_URL = process.env.VUE_APP_ORI_OAI_SERVER
  const BASE_PARAMS = {
    menuKey: 'lom',
    submenuKey: 'advanced',
    fieldId: 'simple_all',
    search: 'true',
    'userChoices[simple_all].simpleValueRequestType': 'default',
  }

  function encodeQueryParams (params) {
    return Object.keys(params).map(function(key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
    }).join('&');
  }

  export default {
    name: "Resource",
    computed: {
      ...mapGetters(['linksInNewTab']),
      searchUrl: function () {
        const params = {...BASE_PARAMS, 'userChoices[simple_all].simpleValue': this.searchCriteria}
        return `${BASE_URL}?${encodeQueryParams(params)}`
      },
      criteriaMissing() {
        return !this.searchCriteria.length
      }
    },
    methods: {
      doSearch: function () {
        if (!this.searchCriteria.length) {
          return false
        }
        if (this.linksInNewTab) {
          window.open(this.searchUrl)
        } else {
          window.location = this.searchUrl
        }
      }
    },
    data: () => ({
      searchCriteria: ""
    })
  }
</script>

<style lang="scss" scoped>
@import 'src/scss/constants.scss';

#resource {
  padding: 15px 10px;

  h2 {
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    font-size: 40px;
    line-height: 45px;
    color: black;
    margin-bottom: 30px;
    @media screen and (max-width: $mediaXSmall){
      font-size: 26px;
      margin-bottom: 20px;
    }
  }
  .v-btn{
    font-weight: 700;
  }

  .v-input::v-deep {
    .v-input__slot{
      background-color: white;
      border-radius: unset;
    }
    input {
      font-family: 'Poppins', sans-serif;
      font-weight: 500;
      font-size: 18px;
    }
  }
}

</style>
